import * as THREE from 'three';

export interface IARAnchor {
  pozisyon: THREE.Vector3;
  rotasyon: THREE.Euler;
  olcek: THREE.Vector3;
  kilitli: boolean;
  olusturmaZamani: number;
}

export class FikoARAnchor {
  private _anchor: IARAnchor | null = null;
  private _hedefGrup: THREE.Group | null = null;

  get kilitli(): boolean {
    return this._anchor?.kilitli ?? false;
  }

  get anchor(): IARAnchor | null {
    return this._anchor;
  }

  bagla(grup: THREE.Group): void {
    this._hedefGrup = grup;
  }

  sabitle(): void {
    if (!this._hedefGrup) return;

    this._anchor = {
      pozisyon: this._hedefGrup.position.clone(),
      rotasyon: this._hedefGrup.rotation.clone(),
      olcek: this._hedefGrup.scale.clone(),
      kilitli: true,
      olusturmaZamani: Date.now()
    };
  }

  serbest(): void {
    if (this._anchor) {
      this._anchor.kilitli = false;
    }
  }

  sifirla(): void {
    this._anchor = null;
    if (this._hedefGrup) {
      this._hedefGrup.position.set(0, 0, 0);
      this._hedefGrup.rotation.set(0, 0, 0);
      this._hedefGrup.scale.set(1, 1, 1);
    }
  }

  geriYukle(): void {
    if (!this._anchor || !this._hedefGrup) return;
    this._hedefGrup.position.copy(this._anchor.pozisyon);
    this._hedefGrup.rotation.copy(this._anchor.rotasyon);
    this._hedefGrup.scale.copy(this._anchor.olcek);
  }

  dispose(): void {
    this._anchor = null;
    this._hedefGrup = null;
  }
}
